import { render, staticRenderFns } from "./PUdetailspr.vue?vue&type=template&id=456b5026&scoped=true&"
import script from "./PUdetailspr.vue?vue&type=script&lang=js&"
export * from "./PUdetailspr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b5026",
  null
  
)

export default component.exports